import { render, staticRenderFns } from "./MiFileUpload.vue?vue&type=template&id=5b8840bc&scoped=true"
import script from "@/components/mi-file-upload/MiFileUpload.ts?vue&type=script&lang=ts&external"
export * from "@/components/mi-file-upload/MiFileUpload.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/mi-file-upload/mi-file-upload.scss?vue&type=style&index=0&id=5b8840bc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8840bc",
  null
  
)

export default component.exports